import React, { useState } from 'react'

import { Table, Tooltip, Text, Box, ActionIcon, Flex, Menu, Badge } from '@mantine/core';
import { HiOutlineTrash, HiOutlinePencilAlt, HiDotsVertical, HiReceiptTax } from "react-icons/hi";
import { MdOutlineAccountCircle, MdOutlineMail, MdOutlinePhone, MdOutlinePhoneIphone, MdKeyboardArrowUp, MdKeyboardArrowDown, MdMonetizationOn } from "react-icons/md";
import dayjs from 'dayjs'
import 'dayjs/locale/es'

const CustomerRow = ({ item, onOpen, openConfirm, openRecordModal, _openManualRenovation }) =>
{
  const [ show, setShow ] = useState(false)
  
  return (
    <>
      <Table.Tr 
        className={`transition-colors duration-200 ${show ? 'bg-slate-50' : 'hover:bg-slate-50/50'}`}
        style={show ? { borderLeft: '4px solid var(--mantine-color-yellow-filled)' } : { borderLeft: '4px solid transparent' }}
      >
        <Table.Td px="md" py="lg">
          <Text fw={700} size="sm" c="dark.4">{ item.num_account }</Text>
        </Table.Td>
        <Table.Td align="left">
          <Text fw={600} size="sm">{ item?.full_name || 'N/A' }</Text>
        </Table.Td>

        <Table.Td>
          <Badge variant="light" color="gray" radius="sm">
            { dayjs(item?.date_billing).locale('es').format('DD/MMM/YYYY').toUpperCase() }
          </Badge>
        </Table.Td>
        <Table.Td>
          <Badge variant="light" color="yellow" radius="sm">
            { dayjs(item?.limit_date_billing).locale('es').format('DD/MMM/YYYY').toUpperCase() }
          </Badge>
        </Table.Td>
        <Table.Td>
          <Flex justify="flex-end" align="center" gap="xs">
            <Tooltip label={show ? 'Cerrar detalles' : 'Ver detalles'} fontSize='xs'>
              <ActionIcon 
                onClick={ () => setShow(!show) } 
                variant={show ? 'filled' : 'light'} 
                color="yellow" 
                size="lg" 
                radius="md"
              >
                { show ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown /> }
              </ActionIcon>
            </Tooltip>
            
            <Menu shadow="md" width={ 220 } radius="md" withArrow>
              <Menu.Target>
                <ActionIcon variant='subtle' color="gray.6" size="lg" radius="md">
                  <HiDotsVertical/>
                </ActionIcon>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Label>Acciones de Cliente</Menu.Label>
                <Menu.Item onClick={ () => onOpen(item, true) } leftSection={<HiOutlinePencilAlt size={16} />} aria-label='Editar cliente'>
                  Editar perfil
                </Menu.Item>

                <Menu.Item onClick={ () => openRecordModal(item.num_account) } leftSection={<HiReceiptTax size={16} />} aria-label='Ver historial de pago '>
                  Historial de pagos
                </Menu.Item>
                
                <Menu.Divider />
                <Menu.Label>Operaciones</Menu.Label>
                <Menu.Item color="yellow" onClick={ () => _openManualRenovation(item) } leftSection={<MdMonetizationOn size={16} />} aria-label='Nueva renovación'>
                  Nueva renovación
                </Menu.Item>

                <Menu.Divider />
                <Menu.Item
                  color="red"
                  onClick={ () => openConfirm(item) } 
                  aria-label='Borrar cliente'
                  leftSection={<HiOutlineTrash size={16} />}
                >
                  Dar de baja
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </Flex>
        </Table.Td>
      </Table.Tr>
      
      { show && (
        <Table.Tr style={{ borderLeft: '4px solid var(--mantine-color-yellow-filled)', backgroundColor: 'var(--mantine-color-slate-50)' }}>
          <Table.Td colSpan={ 5 } px="xl" py="lg">
            <Box className='grid grid-cols-2 gap-4 mb-4'>
              <Text fw={800} size="md" c="yellow.9">DETALLES DE LA CUENTA</Text>
              <Text size='xs' c="dimmed" textAlign="right">
                ALTA DE SERVICIO: { dayjs(item?.start_from).locale('es').format('DD/MMM/YYYY').toUpperCase() }
              </Text>
            </Box>
            
            <Flex gap="xl" wrap="wrap">
              <Box style={{ flex: 2 }}>
                <Text size="xs" fw={700} c="dimmed" mb="xs">CONTACTO</Text>
                <Box className='grid grid-cols-2 gap-y-2'>
                  <Flex align="center" gap="xs"><MdOutlineAccountCircle size={18} className="text-yellow-600" /> <Text size="sm">{ item?.full_name || 'N/A' }</Text></Flex>
                  <Flex align="center" gap="xs"><MdOutlineMail size={18} className="text-yellow-600" /> <Text size="sm">{ item?.email || 'N/A' }</Text></Flex>
                  <Flex align="center" gap="xs"><MdOutlinePhone size={18} className="text-yellow-600" /> <Text size="sm">{ item?.phone || 'N/A' }</Text></Flex>
                  <Flex align="center" gap="xs"><MdOutlinePhoneIphone size={18} className="text-yellow-600" /> <Text size="sm">{ item?.cellphone || 'N/A' }</Text></Flex>
                </Box>
              </Box>
              
              <Box style={{ flex: 1 }}>
                <Text size="xs" fw={700} c="dimmed" mb="xs">CONTRATO</Text>
                <Box className='grid gap-y-1'>
                  <Text size="sm"><b>Modalidad:</b> { item?.type_contract }</Text>
                  <Text size="sm"><b>Plan:</b> { item?.name_type_plan }</Text>
                  <Text size="sm"><b>Tolerancia:</b> { item?.limit_payday } días</Text>
                </Box>
              </Box>

              <Box style={{ flex: 1 }}>
                <Text size="xs" fw={700} c="dimmed" mb="xs">REFERENCIA</Text>
                <Badge size="lg" radius="sm" color="yellow" variant="filled" fullWidth>
                  { item?.payment_reference || 'SIN REF' }
                </Badge>
              </Box>
            </Flex>
          </Table.Td>
        </Table.Tr>
      ) }
    </>
  )
}

export default CustomerRow
